module.exports = __webpack_public_path__ + "img/text-mark7.b2a04367.png";